import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { imgUrl } from "../../lib/api";
import { useLang } from "../../i18n";

export default function ProductsAdmin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const load = () => api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/admin/products/${id}`).catch(() => {});
    toast.success("✓");
    load();
  };

  return (
    <div data-testid="admin-products">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-bold">{t("admin.products")}</h1>
        <button onClick={() => navigate("/admin/prodotti/nuovo")} data-testid="admin-new-product-btn"
          className="flex items-center gap-2 bg-gold text-obsidian px-5 py-2.5 text-sm font-semibold hover:bg-honey transition-colors">
          <Plus size={15} /> {t("admin.new.product")}
        </button>
      </div>
      <div className="mt-8 bg-slate2 border border-slate-700 rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="products-table">
          <thead>
            <tr className="border-b border-slate-700 text-left font-mono text-[10px] uppercase tracking-widest text-slate-400">
              <th className="px-5 py-4">Prodotto</th><th className="px-5 py-4">Categoria</th>
              <th className="px-5 py-4">Prezzi</th><th className="px-5 py-4">Stock</th>
              <th className="px-5 py-4">Lotto</th><th className="px-5 py-4 text-right">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id} className="border-b border-slate-700/50 hover:bg-slate-700/20" data-testid={`product-row-${p.id}`}>
                <td className="px-5 py-3.5">
                  <div className="flex items-center gap-3">
                    <img src={imgUrl(p.image)} alt="" className="w-9 h-9 object-cover rounded" />
                    <span className="font-medium text-slate-200">{p.name_it}{p.featured && <span className="ml-2 text-gold text-xs">★</span>}</span>
                  </div>
                </td>
                <td className="px-5 py-3.5 text-slate-400">{t(`cat.${p.category}`)}</td>
                <td className="px-5 py-3.5 font-mono text-gold text-xs">{p.sizes.map((s) => `${s.label} €${s.price.toFixed(2)}`).join(" / ")}</td>
                <td className="px-5 py-3.5 font-mono">{p.stock}</td>
                <td className="px-5 py-3.5 font-mono text-xs text-slate-400">#{p.batch}</td>
                <td className="px-5 py-3.5 text-right">
                  <button onClick={() => navigate(`/admin/prodotti/modifica/${p.id}`)} data-testid={`edit-product-${p.id}`} className="p-2 text-slate-400 hover:text-gold transition-colors"><Pencil size={15} /></button>
                  <button onClick={() => remove(p.id)} data-testid={`delete-product-${p.id}`} className="p-2 text-slate-400 hover:text-red-400 transition-colors"><Trash2 size={15} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
